import { useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate, Link } from "react-router-dom";
import { UserContext } from "../context/User.context";
import {
  Login,
  Main,
  Home,
  DashboardUser,
  ProductTable,
  ProfileUser,
  ChangePassword,
  ProfileEdit,
  DetailVisitor,
} from "../layout/index";
import {
  FormVisitor,
  ViewVisitor,
  VisitorComponent,
  DetailVisior,
  SearchDetailVisitor,
} from "../layout/guest/index";

import {
  GridCard,
  DetailCard,
  StatisticsVisitor,
  VisitorForm,
} from "../layout/admin/index";
import { InstitutionTable } from "../layout/admin/institution/Table";
import { DetailInstitutionVisit } from "../layout/admin/institution/View";
import { PatrolTable } from "../layout/admin/patrol/Table";
import { LocationTable } from "../layout/admin/location/TableLocation";
import { LocationDetail } from "../layout/admin/location/Detail";
import { PatrolDetail } from "../layout/admin/patrol/Detail";
import AddLocationForm from "../layout/admin/location/AddForm";
import { UsersTable } from "../layout/admin/users/TableListUser";
import { DetailUser } from "../layout/admin/users/DetailUser";

const MainRouter = () => {
  const { user } = useContext(UserContext);
  const PrivateRoute = ({ children }) => {
    // Handle Back To Login
    if (user) {
      return children;
    } else {
      return <Navigate to="/login" replace={true} />;
    }
  };

  const LoginRoute = ({ children }) => {
    if (user) {
      return <Navigate to="/user" replace={true} />;
    } else {
      return children;
    }
  };
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Auth */}
          <Route
            path="/login"
            element={
              <LoginRoute>
                <Login />
              </LoginRoute>
            }
          />

          {/* <Route
            path="/register"
            element={
              <LoginRoute>
                <Register />
              </LoginRoute>
            }
          /> */}

          <Route path="/" element={<Main />}>
            <Route index element={<Home />} />
          </Route>
          <Route path="visitor" element={<FormVisitor />} />
          <Route path="visitor/:id" element={<DetailVisior />} />
          <Route path="scan" element={<SearchDetailVisitor />} />

          <Route path="/user" element={<DashboardUser />}>
            <Route
              path="profile"
              element={
                <PrivateRoute>
                  <ProfileUser />
                </PrivateRoute>
              }
            />

            <Route
              path="change-pwd"
              element={
                <PrivateRoute>
                  <ChangePassword />
                </PrivateRoute>
              }
            />

            <Route
              path="profile-edit"
              element={
                <PrivateRoute>
                  <ProfileEdit />
                </PrivateRoute>
              }
            />
            <Route
              path="statistic"
              element={
                <PrivateRoute>
                  <StatisticsVisitor />
                </PrivateRoute>
              }
            />
            <Route
              path="patrol-list"
              element={
                <PrivateRoute>
                  <PatrolTable />
                </PrivateRoute>
              }
            />
            <Route
              path="patrol/detail/:id"
              element={
                <PrivateRoute>
                  <PatrolDetail />
                </PrivateRoute>
              }
            />

            <Route
              path="location-list"
              element={
                <PrivateRoute>
                  <LocationTable />
                </PrivateRoute>
              }
            />
            <Route
              path="location/detail/:code"
              element={
                <PrivateRoute>
                  <LocationDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="location-add"
              element={
                <PrivateRoute>
                  <AddLocationForm />
                </PrivateRoute>
              }
            /> 
            <Route
              path="users-list"
              element={
                <PrivateRoute>
                  <UsersTable />
                </PrivateRoute>
              }
            />

             <Route
              path="users/detail/:id"
              element={
                <PrivateRoute>
                  <DetailUser />
                </PrivateRoute>
              }
            />

            <Route
              path="institution"
              element={
                <PrivateRoute>
                  <InstitutionTable />
                </PrivateRoute>
              }
            />
            <Route
              path="institution/:code"
              element={
                <PrivateRoute>
                  <DetailInstitutionVisit />
                </PrivateRoute>
              }
            />
            <Route
              path="card-list"
              element={
                <PrivateRoute>
                  <GridCard />
                </PrivateRoute>
              }
            />
            <Route
              path="detail/card/:code"
              element={
                <PrivateRoute>
                  <DetailCard />
                </PrivateRoute>
              }
            />

            <Route
              index
              element={
                <PrivateRoute>
                  <ProductTable />
                </PrivateRoute>
              }
            />
            <Route
              path="detail/:code"
              element={
                <PrivateRoute>
                  <DetailVisitor />
                </PrivateRoute>
              }
            />
            <Route
              path="visitor/create"
              element={
                <PrivateRoute>
                  <VisitorForm />
                </PrivateRoute>
              }
            />
            <Route
              path="scan"
              element={
                <PrivateRoute>
                  {/* <ScanProduct /> */}
                  <SearchDetailVisitor />
                </PrivateRoute>
              }
            />
          </Route>

          <Route path="*" element={<NoMatchPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

function NoMatchPage() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Back to login</Link>
      </p>
    </div>
  );
}

export default MainRouter;
